module.exports = __webpack_public_path__ + "img/31.5e8cdb20.png";